<script lang="ts" setup>
import { PhArrowRight } from '@phosphor-icons/vue'
import { useI18n } from 'vue-i18n'
import { computed, onMounted, ref } from 'vue'

import { BlockContainer, NewsletterTeaser, NewsletterTeaserContent, NewsletterTeaserText, NewsletterIcon, SectionTitleHeading, Button } from '@toni/brand-ui'

import { usePageStore } from '../../../stores/page'
import { usePageBlockWidth } from '../../../composables/use-page-block-width.ts'

const { t } = useI18n()
const pageStore = usePageStore()
const currentBrand = computed(() => pageStore.brandFromStore || 'todaysgolfer')

const buttonSize = ref<'sm' | 'md' | 'lg' | 'xl'>('md')

const updateButtonSize = () => {
  buttonSize.value = window.innerWidth >= 768 ? 'xl' : 'lg'
}

onMounted(() => {
  updateButtonSize()
  window.addEventListener('resize', updateButtonSize)
})

const isHome = computed(() => pageStore.isHome as boolean)
const brandName = computed(() => pageStore.brandFromStore as string)
const size = computed(() => usePageBlockWidth(pageStore.pageData?.pageMeta, isHome.value, brandName.value).value)
</script>

<template>
  <BlockContainer :size="size">
    <NewsletterTeaser>
      <NewsletterTeaserContent>
        <NewsletterIcon class="w-20 h-20 md:w-24 md:h-24 pb-1" />
        <SectionTitleHeading class="pt-4 pb-6 text-heading-md md:text-heading-xl">
          {{ t(`newsletterTeaser.${currentBrand}.headline`) }}
        </SectionTitleHeading>
        <NewsletterTeaserText>
          {{ t(`newsletterTeaser.${currentBrand}.mainText`) }}
        </NewsletterTeaserText>
        <Button variant="primary"
                :size="buttonSize"
                href="/newsletter"
                target="_self">
          {{ t(`newsletterTeaser.${currentBrand}.buttonText`) }}
          <PhArrowRight weight="bold"
                        class="w-5 h-5" />
        </Button>
      </NewsletterTeaserContent>
    </NewsletterTeaser>
  </BlockContainer>
</template>
